
const bankSlipMercadoPago = {
    validate: (data) => {

        let valid = true;
        let errors = [];

        if (data.first_name.length < 3) {
            errors.push('Nome inválido');
            valid = false;
        }
        if (data.last_name.length < 3) {
            errors.push('Sobre nome inválido!');
            valid = false;
        }
        if (data.cpf < 11) {
            errors.push('CPF inválido!');
            valid = false;
        }
        const cepPattern = /^\d{5}-\d{3}$/
        if (!cepPattern.test(data.cep)) {
            errors.push('inválido');
            valid = false;
        }

        return {'status': valid, errors};
        
    }
}

export default bankSlipMercadoPago;